import React, { useEffect, useRef, useState } from 'react';
import ForgotPassword from './ForgotPassword.component';
import { forgotPassword } from '../../store/actions/login.actions';
import { useDispatch, useSelector } from 'react-redux';
import { Platform } from 'react-native';
import routes from '../../config/routes';
import { getIsMaintenance } from '../../store/selectors/config.selectors';
import { CheckIdResult } from '../SignInV2/SignInV2.api';
import { resolveResetTarget } from '../SignInV2/SignInV2.utils';

interface ForgotPasswordContainerProps {
	navigation: any;
	/** set when the screen is opened as a route rather than rendered in a flow */
	route?: any;
	/** the id the caller already collected - this screen never asks for it again */
	idNumber?: string;
	/** where the back/close links lead when the screen is opened from another flow */
	onBack?: () => void;

	profile?: CheckIdResult | null;
}

const ForgotPasswordContainer = ({
	navigation,
	route,
	idNumber,
	onBack,
	profile,
}: ForgotPasswordContainerProps) => {
	const dispatch = useDispatch();
	const teudatZeut: string = idNumber || route?.params?.idNumber || '';
	const [didResetPassword, setDidResetPassword] = useState(false);
	const [hasError, setHasError] = useState(false);
	const [captchaVerified, setCaptchaVerified] = useState<boolean>(false);
	const [submitted, setSubmitted] = useState(false);
	const recaptchaRef = useRef();
	const isMaintenance = useSelector(getIsMaintenance);
	const resetTarget = resolveResetTarget(
		profile || route?.params?.profile || null,
	);

	useEffect(() => {
		isMaintenance && navigation.navigate(routes.signIn.name);
	}, [isMaintenance]);

	// the api resets by id, so without one there is nothing to send - back to the
	// id step rather than stranding the user on a screen that can't submit
	useEffect(() => {
		!teudatZeut && navigation.navigate(routes.signIn.name);
	}, [teudatZeut]);

	const sendEmailForgotPswHandler = async () => {
		setSubmitted(true);
		if (Platform.OS !== 'web' || captchaVerified) {
			const res: any = await dispatch(forgotPassword(teudatZeut));
			if (res) {
				setDidResetPassword(true);
			} else {
				setHasError(true);
			}
		}
	};

	const onCaptchaChange = (value: any) => {
		setCaptchaVerified(true);
	};

	const onExpiredCaptcha = () => {
		setCaptchaVerified(false);
	};

	/** back to the id step - in-flow when possible, by route otherwise */
	const backHandler = () => {
		if (onBack) {
			onBack();
			return;
		}
		navigation.navigate(routes.signIn.name);
	};

	return (
		<ForgotPassword
			didResetPassword={didResetPassword}
			onBack={backHandler}
			sendEmailForgotPsw={sendEmailForgotPswHandler}
			hasError={hasError}
			onCaptchaChange={onCaptchaChange}
			onExpiredCaptcha={onExpiredCaptcha}
			captchaVerified={captchaVerified}
			submitted={submitted}
			resetTarget={resetTarget}
			ref={recaptchaRef}
		/>
	);
};

export default ForgotPasswordContainer;
